module.exports = "/packs/images/svg/alert-close~7037fb018eb720fbeb608ba5587f642f.svg";